import React from 'react';

import Tab, { TabGroup as TabGroupLib } from '@amzn/meridian/tab';
import {
  PLACEMENT_OVERVIEW_TABS,
  type PlacementOverviewTab,
} from 'src/components/pages/placementsOverview/placementOverviewTabs';
import {
  selectHasTransferredInPlacements,
  selectVisibleAllPlacementsTableData,
} from 'src/store/placementOverviewPageSlice';
import { useAppSelector } from 'src/store/store';

interface TabGroupProps {
  currentTab: PlacementOverviewTab;
  onTabChange: (newTab: PlacementOverviewTab) => void;
}

const TabGroup = ({ currentTab, onTabChange }: TabGroupProps) => {
  const allPlacementsTableData = useAppSelector(selectVisibleAllPlacementsTableData);
  const hasTransferredInPlacements = useAppSelector(selectHasTransferredInPlacements);
  const {
    activePlacementsTableData,
    expiredPlacementsTableData,
    pendingPlacementsTableData,
    closedPlacementsTableData,
    transferredInPlacementsTableData,
  } = useAppSelector((state) => state.placementOverviewPage);
  const { featureFlags } = useAppSelector((state) => state.user);

  return (
    <TabGroupLib value={currentTab} onChange={(newTab) => onTabChange(newTab as PlacementOverviewTab)}>
      <Tab value={PLACEMENT_OVERVIEW_TABS.ALL_STATUSES}>All Statuses ({allPlacementsTableData.length})</Tab>
      <Tab value={PLACEMENT_OVERVIEW_TABS.PENDING_DECISIONS}>
        Pending Decisions ({pendingPlacementsTableData.length})
      </Tab>
      <Tab value={PLACEMENT_OVERVIEW_TABS.IN_PROGRESS}>In Progress ({activePlacementsTableData.length})</Tab>
      <Tab value={PLACEMENT_OVERVIEW_TABS.OVERDUE}>Overdue ({expiredPlacementsTableData.length})</Tab>
      <Tab value={PLACEMENT_OVERVIEW_TABS.CLOSED}>Closed ({closedPlacementsTableData.length})</Tab>
      {featureFlags.PLACEMENT_TRANSFER && hasTransferredInPlacements && (
        <Tab value={PLACEMENT_OVERVIEW_TABS.TRANSFERRED_IN}>
          Transferred in ({transferredInPlacementsTableData.length})
        </Tab>
      )}
    </TabGroupLib>
  );
};

export default TabGroup;
